<!-- ══════════════════════════════════════════════════════════════════
     HERO — Moteur de recherche
═══════════════════════════════════════════════════════════════════ -->
<section class="loi-hero">
    <div class="loi-hero__bg"></div>
    <div class="container">
        <div class="loi-hero__content">
             
            <h1 class="loi-hero__title">{{ 'loi_titre' | translate }}</h1>
            <p class="loi-hero__sub">{{ 'loi_sous_titre' | translate }}</p>

            <!-- Barre de recherche -->
            <form class="loi-search" (ngSubmit)="onSubmit()">
                <div class="loi-search__inner">
                    <i class="icofont-search-1 loi-search__icon"></i>
                    <input class="loi-search__input"
                           type="text"
                           [(ngModel)]="searchQuery"
                           name="q"
                           (input)="onInput()"
                           [placeholder]="'loi_recherche_ph' | translate"
                           autocomplete="off" />
                    <button *ngIf="searchQuery" type="button"
                            class="loi-search__clear"
                            (click)="clearSearch()"
                            title="Effacer">
                        <i class="icofont-close"></i>
                    </button>
                    <button class="loi-search__btn" type="submit">
                        {{ 'loi_rechercher' | translate }}
                    </button>
                </div>
            </form>

            <!-- Compteur -->
            <p class="loi-hero__count" *ngIf="searched && !loading">
                <strong>{{ total }}</strong> {{ 'loi_resultats' | translate }}
                <ng-container *ngIf="searchQuery || activeCategory">
                    — <a class="loi-hero__reset" (click)="clearSearch()" style="cursor:pointer">
                        {{ 'loi_effacer' | translate }}
                    </a>
                </ng-container>
            </p>
        </div>
    </div>
</section>

<!-- ══════════════════════════════════════════════════════════════════
     CORPS — Filtres + Résultats
═══════════════════════════════════════════════════════════════════ -->
<section class="loi-body">
    <div class="container">
        <div class="row gutter-y-40">

            <!-- ── Colonne gauche : filtres catégorie ──────────────── -->
            <div class="col-lg-3">
                <div class="loi-filters">
                    <h4 class="loi-filters__title">
                        <i class="icofont-tag"></i>
                        {{ 'loi_categories' | translate }}
                    </h4>
                    <ul class="loi-filters__list list-unstyled">

                        <!-- Toutes -->
                        <li>
                            <button class="loi-filter-btn"
                                    [class.active]="activeCategory === ''"
                                    (click)="setCategory('')">
                                <span class="loi-filter-btn__label">{{ 'loi_toutes' | translate }}</span>
                                <span class="loi-filter-btn__count">{{ total }}</span>
                            </button>
                        </li>

                        <!-- Par catégorie (chargées depuis l'API) -->
                        <li *ngIf="loadingCats">
                            <div class="loi-filter-skeleton" *ngFor="let i of [1,2,3,4,5]"></div>
                        </li>
                        <li *ngFor="let cat of categories">
                            <button class="loi-filter-btn"
                                    [class.active]="activeCategory === cat.key"
                                    (click)="setCategory(cat.key)">
                                <span class="loi-filter-btn__dot" [class]="getCategoryColor(cat.key)"></span>
                                <span class="loi-filter-btn__label">{{ tf(cat.labels) }}</span>
                                <span class="loi-filter-btn__count">{{ cat.total }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- ── Colonne droite : résultats ──────────────────────── -->
            <div class="col-lg-9">

                <!-- Chargement -->
                <app-loading *ngIf="loading"></app-loading>

                <!-- Erreur -->
                <div *ngIf="error && !loading" class="loi-error">
                    <i class="icofont-warning-alt"></i>
                    <p>{{ error | translate }}</p>
                </div>

                <!-- Résultats -->
                <ng-container *ngIf="!loading && !error">

                    <!-- Aucun résultat -->
                    <div *ngIf="articles.length === 0 && searched" class="loi-empty">
                        <i class="icofont-search-document"></i>
                        <h4>{{ 'loi_aucun_resultat' | translate }}</h4>
                        <p *ngIf="searchQuery">{{ 'loi_aucun_hint' | translate }}</p>
                        <button class="careox-btn" (click)="clearSearch()">
                            {{ 'loi_effacer' | translate }}
                        </button>
                    </div>

                    <!-- Liste des articles -->
                    <div class="loi-results" *ngIf="articles.length > 0">
                        <div class="loi-card wow fadeInUp"
                             data-wow-duration="600ms"
                             *ngFor="let art of articles; let i = index"
                             [attr.data-wow-delay]="(i % 5) * 80 + 'ms'">

                            <div class="loi-card__header">
                                <!-- Badge catégorie -->
                                <span class="loi-badge" [class]="getCategoryColor(art.category)">
                                    {{ getCategoryLabel(art.category) }}
                                </span>
                                <!-- Numéro d'article -->
                                <span class="loi-card__num">
                                    <i class="icofont-document-folder"></i>
                                    {{ art.article_number }}
                                </span>
                                <!-- Date -->
                                <span class="loi-card__date">
                                    <i class="icofont-calendar"></i>
                                    {{ formatDate(art.published_at) }}
                                </span>
                            </div>

                            <div class="loi-card__body">
                                <h3 class="loi-card__title">
                                    <a [routerLink]="['/loi', art.id]">
                                        {{ tf(art.title) }}
                                    </a>
                                </h3>
                                <p class="loi-card__ref" *ngIf="art.law_reference">
                                    <i class="icofont-link"></i> {{ art.law_reference }}
                                </p>
                                <p class="loi-card__excerpt" *ngIf="tf(art.excerpt)">
                                    {{ tf(art.excerpt) | slice:0:220 }}{{ tf(art.excerpt).length > 220 ? '…' : '' }}
                                </p>
                                <!-- Tags -->
                                <div class="loi-card__tags" *ngIf="art.tags?.length">
                                    <span class="loi-tag" *ngFor="let tag of art.tags">{{ tag }}</span>
                                </div>
                            </div>

                            <div class="loi-card__footer">
                                <a [routerLink]="['/loi', art.id]" class="loi-card__link">
                                    {{ 'loi_consulter' | translate }}
                                    <i class="icofont-double-right"></i>
                                </a>
                            </div>

                        </div>
                    </div>

                    <!-- Pagination -->
                    <nav class="loi-pagination" *ngIf="totalPages > 1">
                        <button class="loi-page-btn"
                                [disabled]="page <= 1"
                                (click)="loadPage(page - 1)">
                            <i class="icofont-double-left"></i>
                        </button>

                        <button *ngIf="page > 3" class="loi-page-btn" (click)="loadPage(1)">1</button>
                        <span *ngIf="page > 4" class="loi-page-ellipsis">…</span>

                        <button *ngFor="let p of pages"
                                class="loi-page-btn"
                                [class.active]="p === page"
                                (click)="loadPage(p)">{{ p }}</button>

                        <span *ngIf="page < totalPages - 3" class="loi-page-ellipsis">…</span>
                        <button *ngIf="page < totalPages - 2" class="loi-page-btn"
                                (click)="loadPage(totalPages)">{{ totalPages }}</button>

                        <button class="loi-page-btn"
                                [disabled]="page >= totalPages"
                                (click)="loadPage(page + 1)">
                            <i class="icofont-double-right"></i>
                        </button>
                    </nav>

                </ng-container>

            </div><!-- /col-lg-9 -->
        </div><!-- /row -->
    </div>
</section>
